"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserListExcel = exports.fetchProjectUserList = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const sok_types_1 = require("@caddigital/sok-types");
const ActionTypes = require("../../actionTypes/project/users");
const Actions = require("../../actions/project/users");
const errorHandling_1 = require("../../utils/errorHandling");
const toast_1 = require("../../actions/toast");
const translation_1 = require("../../utils/translation");
function fetchProjectUserList(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_PROJECT_USER_LIST_REQUEST), (0, operators_1.mergeMap)((request) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/project/${request.payload.id}/userlist`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t.array(sok_types_1.User.iUser).decode(response);
        const act = validation.fold((e) => Actions.fetchProjectUserListFailure((0, errorHandling_1.parseValidationError)(e)), (users) => Actions.fetchProjectUserListSuccess(users));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.fetchProjectUserListFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.fetchProjectUserList = fetchProjectUserList;
function getUserListExcel(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_PROJECT_USER_LIST_EXCEL_REQUEST), (0, operators_1.mergeMap)((request) => ajax({
        headers: {
            Authorization: getToken(),
            'Content-Type': 'application/json'
        },
        responseType: 'blob',
        method: 'GET',
        url: `${baseUrl}api/project/${request.payload.id}/userlist?format=excel`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const blob = response;
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'projects.xlsx';
        link.click();
        return (0, rxjs_1.of)(Actions.fetchProjectUserListExcelSuccess());
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.merge)((0, rxjs_1.of)((0, toast_1.addNewToast)((0, translation_1.getLocalization)('toast/export_parties_list_failed'), (0, translation_1.getLocalization)('toast/export_parties_list_failed_details'), 'FAILURE', [])), (0, rxjs_1.of)(Actions.fetchProjectUserListExcelFailure((0, errorHandling_1.parseAjaxErrorResponse)(e))))))));
}
exports.getUserListExcel = getUserListExcel;
//# sourceMappingURL=users.js.map